
import mediaType from "../Constants/mediaType.js";

const ImageSlider = ({ media = [], maxImages = 8 }) => {
  const imageMedia = media
    .filter((mediaItem) => mediaItem.mediaType === mediaType.IMAGE)
    .slice(0, maxImages);

  return (
    <div className="mt-3">
      {/* <div className="font-bold text-[#1a1a1a] mb-2">
        Images:
      </div> */}
     
        <div 
          className="flex overflow-x-auto gap-2 pb-1"
          style={{ scrollbarWidth: "thin", scrollbarColor: "#cbd5e0 #f7fafc", WebkitOverflowScrolling: "touch" }}
        >
          {imageMedia&&imageMedia?.map((mediaItem, imgIndex) => {
            const imageUrl =
              mediaItem.signedUrl ||
              (mediaItem.path
                ? `${process.env.REACT_APP_MEDIA_URL || ""}${mediaItem.path}`
                : null);
            return imageUrl ? (
              <img
                key={imgIndex}
                src={imageUrl}
                alt={`Image ${imgIndex + 1}`}
                className="min-w-[120px] w-[120px] h-[120px] object-cover rounded cursor-pointer shrink-0"
                onError={(e) => {
                  e.target.onerror = null;
                }}
              />
            ) : null;
          })}
        </div>
    
    </div>
  );
};

export default ImageSlider;
